<script setup lang="ts">
  import { type PropType } from 'vue';
  import type { Breadcrumb, Section } from '$types';

  defineProps({
    breadcrumbs: { type: Array as PropType<Breadcrumb[]>, required: true },
    sections: { type: Array as PropType<Section[]>, required: true },
    price: { type: Object, required: true },
    attributes: { type: Object, required: true },
    module: { type: Object, required: true },
    category: { type: Object, required: false },
    brands: { type: Object, required: true },
    search: { type: String, required: false },
    options: { type: Object, required: true },
    categories: { type: Object, required: true },
    products: { type: Object, required: true },
    page: { type: Object, required: true },
    show_mode: { type: String as PropType<'CATEGORIES' | 'PRODUCTS'>, required: true },
  });
</script>
<template>
  <main>
    <div class="container">
      <SfBreadcrumbs :breadcrumbs />
    </div>
    <SectionRenderer :sections="sections" placement="before" class="container-shop__before" />
    <section class="container container-shop">
      <ShopProductsHeading :search :category :module :total="products.total" class="container-shop__products-heading" />
      <ShopProductsGridProducts v-if="show_mode === 'PRODUCTS'" v-bind="$props" />
      <ShopProductsGridCategories v-else v-bind="$props" />
    </section>
    <SectionRenderer :sections="sections" placement="after" />
  </main>
</template>
<style lang="scss" scoped>
  main {
    overflow: hidden;
  }

  .container-shop {
    --sf-products-heading-color: var(--color-main-black);
    --sf-products-heading-size: 2.25rem;
    --sf-products-heading-quantity-size: 1rem;
    --sf-products-heading-quantity-color: var(--color-primary-gray);

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
    padding-bottom: 6.25rem;

    &__before {
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 992px) {

    main {
      margin-bottom: 1rem;
    }

    .container-shop {
      gap: 1rem;
      padding-bottom: 2rem;

      &__products-heading {
        padding: 0 1rem;
      }
    }
  }
</style>
